// JS that is applicable to all HubSpot forms, callbacks.

// eslint-disable-next-line no-unused-vars
function hideFormPlaceholder() {
  const placeholder = document.querySelector(".hs-form-placeholder");
  if (placeholder) {
    placeholder.style.display = "none";
  }
}
